var _dec, _class, _class2, _temp;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { PureComponent } from 'react';
import Portal from './Portal';
import warnIfDeprecated from '../utils/warnIfDeprecated';
var Popup = (_dec = warnIfDeprecated([{
  oldProp: 'getContainer',
  newProp: 'mountContainer'
}]), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Popup, _PureComponent);

  _createClass(Popup, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.visible !== state.prevVisible) {
        if (props.visible) {
          return {
            renderPortal: true,
            portalVisible: true
          };
        }

        return {
          portalVisible: false
        };
      }

      return null;
    }
  }]);

  function Popup(props) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popup).call(this, props));
    _this.portalRef = void 0;
    _this.state = {
      renderPortal: false,
      portalVisible: false
    };
    _this.handlePortalUnmount = _this.handlePortalUnmount.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var visible = this.props.visible;

      if (visible) {
        this.setState({
          renderPortal: true,
          portalVisible: true
        });
      }
    }
  }, {
    key: "handlePortalUnmount",
    value: function handlePortalUnmount() {
      var destroy = this.props.destroy;

      if (destroy) {
        this.setState({
          renderPortal: false
        });
      } else {
        this.setState({
          renderPortal: true,
          portalVisible: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          renderPortal = _this$state.renderPortal,
          portalVisible = _this$state.portalVisible;
      return renderPortal && React.createElement(Portal, _extends({
        ref: function ref(_ref) {
          _this2.portalRef = _ref;
        }
      }, this.props, {
        visible: portalVisible,
        handlePortalUnmount: this.handlePortalUnmount
      }));
    }
  }]);

  return Popup;
}(PureComponent), _class2.defaultProps = {
  prefixCls: 'za-popup',
  destroy: true
}, _temp)) || _class);
export { Popup as default };